export const AI_PROXY_API_ROUTE = '/api/ai-api';
